export default customElements.define('w-header', class Header extends wealthify.CustomElementBaseClass {

    constructor() {
        const styleSelector = 'c-header';
        const currentEnvironmentAssetPath = wealthify.settings.currentAssetPath;
        const config = {
            styleSelector,
            templateHTML: /*html*/`
                <header data-root>
                    <a class="${styleSelector}__skip-to-main-content-link" href="#siteContent">
                      Skip to content
                    </a>
                    <w-wrapper class="u-padding__top-mobile--0 u-padding__bottom-mobile--0 u-display__flex" justifycontent="space-between">
                        <div class="${styleSelector}__logo-container">
                            <img src="${currentEnvironmentAssetPath}/images/partners/aviva/aviva-stacked-yellow.png" alt="You've reached us via Aviva." class="${styleSelector}__aviva-logo u-display__none" data-aviva-logo>
                            <a href="" class="${styleSelector}__wealthify-link" data-wealthify-link>
                                <img src="${currentEnvironmentAssetPath}/images/logos/logo.svg" alt="Wealthify, an Aviva company. Return to homepage." class="u-display__block" data-wealthify-logo>
                            </a>
                            <div class="${styleSelector}__introducer-wrapper u-display__none" data-introducer-wrapper>
                                <p class="u-margin__bottom-mobile--0">Introduced by</p>
                                <img src="" alt="" class="${styleSelector}__introducer-logo u-display__block" data-introducer-logo>
                            </div>
                        </div>
                        <w-navigation data-navigation></w-navigation>
                    </w-wrapper>
                </header>
            `,
            cacheDom: ['data-aviva-logo', 'data-wealthify-link', 'data-wealthify-logo', 'data-introducer-wrapper', 'data-introducer-logo', 'data-navigation']
        };

        super(config);

        this.#currentEnvironmentAssetPath = currentEnvironmentAssetPath;
        this.navigation = this.dom.navigation;

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    // public

    navigation = null;

    static get observedProps () {
        return [
            new wealthify.Prop('wealthify-link', {required: true}),
            new wealthify.Prop('secondary-logo'),
            new wealthify.Prop('introducer-name'),
            new wealthify.Prop('is-aviva-customer', {
                type: wealthify.propTypes.Boolean(),
                default: false
            }),
            new wealthify.Prop('has-introducer', {
                type: wealthify.propTypes.Boolean(),
                default: false
            }),
            // TODO: 03/02/2023, remove temporary theme prop and use global theming solution
            new wealthify.Prop('theme', {
                type: wealthify.propTypes.ArrayItem(Object.values(wealthify.enums.themes)),
                default: wealthify.enums.themes.Dark
            })
        ];
    }

    static avivaImage = ({
        [wealthify.enums.themes.Light]: '/images/partners/aviva/aviva-stacked-blue.png',
        [wealthify.enums.themes.Dark]: '/images/partners/aviva/aviva-stacked-yellow.png'
    });

    get propCallbacks() {
        return {
            wealthifyLink: () => {
                this.dom.wealthifyLink.href = this.wealthifyLink;
            },
            secondaryLogo: () => {
                this.#updateSecondaryLogo();
            },
            introducerName: () => {
                this.dom.introducerLogo.alt = this.introducerName;
                this.dom.wealthifyLogo.src = this.#wealthifyLogoSrc;

            },
            isAvivaCustomer: () => {
                const componentClassListAction = this.isAvivaCustomer ? 'add' : 'remove';
                const avivaClassListAction = this.isAvivaCustomer ? 'remove' : 'add';

                this.classList[componentClassListAction](`${this.styleSelector}--is-aviva`);
                this.dom.avivaLogo.classList[avivaClassListAction]('u-display__none');

                if (this.companyLogo) {
                    this.#updateSecondaryLogo(this.dom.avivaLogo);
                }

                this.dom.avivaLogo.src = `${this.#currentEnvironmentAssetPath}/${this.constructor.avivaImage[this.theme]}`;
            },
            hasIntroducer: () => {
                const componentClassListAction = this.hasIntroducer ? 'add' : 'remove';
                const introducerClassListAction = this.hasIntroducer ? 'remove' : 'add';

                this.classList[componentClassListAction](`${this.styleSelector}--has-introducer`);
                this.dom.introducerWrapper.classList[introducerClassListAction]('u-display__none');
                this.dom.wealthifyLogo.src = this.#wealthifyLogoSrc;
            },
            theme: () => {
                Object.values(wealthify.enums.themes).forEach((theme) =>
                    this.classList.remove(`${this.styleSelector}--${theme}-theme`)
                );

                this.classList.add(`${this.styleSelector}--theme-${this.theme}`);
                this.navigation.theme = this.theme;
                this.dom.wealthifyLogo.src = this.#wealthifyLogoSrc;
            }
        };
    }

    // private

    #currentEnvironmentAssetPath;
    #inlineWealthifyLogo = '/images/logos/logo.svg';
    #inlineWealthifyLogoLight = '/images/logos/logo--light.svg';
    #stackedWealthifyLogo = '/images/logos/logo-stacked.svg';
    #stackedWealthifyLogoLight = '/images/logos/logo-stacked--light.svg';

    get #wealthifyLogoSrc () {
        return this.#currentEnvironmentAssetPath + (this.hasIntroducer ? this.#wealthifyStackedLogo : this.#wealthifyInlineLogo);
    }

    get #wealthifyInlineLogo () {
        return this.theme === wealthify.enums.themes.Light
            ? this.#inlineWealthifyLogoLight
            : this.#inlineWealthifyLogo;
    }

    get #wealthifyStackedLogo () {
        return this.theme === wealthify.enums.themes.Light
            ? this.#stackedWealthifyLogoLight
            : this.#stackedWealthifyLogo;
    }

    #updateSecondaryLogo (element = this.dom.introducerLogo) {
        const isLinkToImage = this.secondaryLogo.startsWith('http');
        const prefix = !isLinkToImage ? 'data:image;base64,' : '';

        element.src = `${prefix}${this.secondaryLogo}`;
    }
});